import { formatCurrency } from '@brazilian-utils/brazilian-utils';
import dayjs from 'dayjs';
import { isNaN } from 'lodash';

import { listChecklistExecutions } from 'api/checklists';
import { listDrivers } from 'api/drivers';
import { listUsers } from 'api/users';
import { ChecklistExecutionHeader, DriverAssignHeader, UserAssignHeader } from 'containers/Show/VirtualizedHeaderItem';
import { ChecklistExecutionItem, UserItem } from 'containers/Show/VirtualizedItems';
import { ContentRoutes } from 'enums/routes';

export const fields = {
  [ContentRoutes.Routes]: [
    {
      label: 'ID da Rota',
      key: 'id',
      props: { direction: 'row' },
    },
    {
      label: 'Projeto:',
      key: 'project.name',
      props: { direction: 'row' },
    },
    {
      label: 'Contratante:',
      key: 'costumerName',
      props: { direction: 'row' },
    },
    {
      label: 'Frequência:',
      key: 'frequency',
      props: { direction: 'row' },
    },
    {
      label: 'Pontos de Coleta Vinculados:',
      key: 'collectCount',
      props: { direction: 'row' },
    },
    {
      label: 'Pontos de Entrega Vinculados:',
      key: 'deliveryCount',
      props: { direction: 'row' },
    },
    {
      label: 'Motoristas Vinculados:',
      key: 'driversCount',
      props: { direction: 'row' },
    },
    {
      label: 'Distância Total Prevista:',
      key: 'kmCount',
      props: { direction: 'row', suffix: ' km' },
    },
    {
      label: 'Tolerância de atraso:',
      key: 'maxOverdue',
      props: { direction: 'row' },
    },
    {
      label: 'Valor da Rota:',
      key: 'routeCents',
      props: {
        direction: 'row',
        parser: (value: string) => {
          const cents = Number(value);
          if (isNaN(cents)) {
            return value;
          }
          return `R$ ${formatCurrency((Number(value) ?? 0) / 100)}`;
        },
      },
    },
    {
      label: 'Valor da KM excedente:',
      key: 'excessKmCents',
      props: {
        direction: 'row',
        parser: (value: string) => {
          const cents = Number(value);
          if (isNaN(cents)) {
            return value;
          }
          return `R$ ${formatCurrency((Number(value) ?? 0) / 100)}`;
        },
      },
    },
  ],
  [ContentRoutes.Materials]: [
    {
      label: 'Tipo de Acondicionamento',
      key: 'packaging',
      props: { direction: 'column' },
    },
    {
      label: 'Temperatura',
      key: 'temperature',
      props: { direction: 'column' },
    },
    {
      label: 'Tipo de material',
      key: 'type',
      props: { direction: 'column' },
    },
  ],
  [ContentRoutes.Containers]: [
    {
      label: 'Cubagem',
      key: 'cubage',
      props: { direction: 'column', suffix: ' kg' },
    },
    {
      label: 'Dimensões',
      key: 'dimensions',
      props: { direction: 'column' },
    },
  ],
  [ContentRoutes.Partner]: [
    {
      label: 'Regional',
      key: 'regional.name',
      props: { direction: 'row' },
    },
    {
      label: 'Telefone',
      key: 'localPhone',
      props: { direction: 'row' },
    },
    {
      label: 'CNPJ',
      key: 'documentNumber',
      props: { direction: 'row' },
    },
    {
      label: 'Celular',
      key: 'phone',
      props: { direction: 'row' },
    },
    {
      label: 'Razão Social',
      key: 'corporateName',
      props: { direction: 'row' },
    },
    {
      label: 'Endereço',
      key: 'formattedAddress.address',
      props: {
        direction: 'row',
        pr: 6,
      },
    },
    {
      label: 'Contato',
      key: 'contact',
      props: { direction: 'row' },
    },
    {
      label: 'Cidade/UF',
      key: 'formattedAddress.city',
      props: {
        direction: 'row',
        pr: 6,
      },
    },
    {
      label: 'Email',
      key: 'email',
      props: { direction: 'row' },
    },
    {
      label: 'Horário',
      key: 'formattedWorkingHours',
      props: { direction: 'row' },
    },
    {
      label: 'Responsável técnico',
      key: 'accountable',
      props: { direction: 'row' },
    },
    {
      label: 'Documento do responsável técnico',
      key: 'accountableDocumentNumber',
      props: { direction: 'row' },
    },
  ],
  [ContentRoutes.Companies]: [
    {
      label: 'Regional',
      key: 'regional.name',
      props: { direction: 'row' },
    },
    {
      label: 'Telefone',
      key: 'localPhone',
      props: { direction: 'row' },
    },
    {
      label: 'CNPJ',
      key: 'documentNumber',
      props: { direction: 'row' },
    },
    {
      label: 'Celular',
      key: 'phone',
      props: { direction: 'row' },
    },
    {
      label: 'Razão Social',
      key: 'corporateName',
      props: { direction: 'row' },
    },
    {
      label: 'Endereço',
      key: 'formattedAddress.address',
      props: {
        direction: 'row',
        pr: 6,
      },
    },
    {
      label: 'Contato',
      key: 'contact',
      props: { direction: 'row' },
    },
    {
      label: 'Cidade/UF',
      key: 'formattedAddress.city',
      props: {
        direction: 'row',
        pr: 6,
      },
    },
    {
      label: 'Email',
      key: 'email',
      props: { direction: 'row' },
    },
  ],
  [ContentRoutes.Vehicles]: [
    {
      label: 'Placa:',
      key: 'licensePlate',
      props: { direction: 'row' },
    },
    {
      label: 'Cor:',
      key: 'color',
      props: { direction: 'row' },
    },
    {
      label: 'Proprietário:',
      key: 'contract',
      props: { direction: 'row' },
    },
    {
      label: 'Fabricante:',
      key: 'manufacturer',
      props: { direction: 'row' },
    },
    {
      label: 'Renavam:',
      key: 'reindeer',
      props: { direction: 'row' },
    },
    {
      label: 'Inicio do Aluguel:',
      key: 'rentedAt',
      props: {
        direction: 'row',
        parser: (value: Date) => dayjs(value).format('DD/MM/YYYY'),
      },
    },
    {
      label: 'Modelo:',
      key: 'model',
      props: { direction: 'row' },
    },
    {
      label: 'Chassi:',
      key: 'chassis',
      props: { direction: 'row' },
    },
    {
      label: 'Final do Aluguel:',
      key: 'rentDueAt',
      props: {
        direction: 'row',
        parser: (value: Date) => dayjs(value).format('DD/MM/YYYY'),
      },
    },
    {
      label: 'Ano do Modelo:',
      key: 'modelYear',
      props: { direction: 'row' },
    },
    {
      label: 'Data de inclusão na Frota:',
      key: 'inclusionDate',
      props: {
        direction: 'row',
        parser: (value: Date) => dayjs(value).format('DD/MM/YYYY'),
      },
    },
    {
      label: 'Parceiro:',
      key: 'partner.name',
      props: { direction: 'row' },
    },
    {
      label: 'Regional:',
      key: 'regional.name',
      props: { direction: 'row' },
    },
    {
      label: 'Ano de Fabricação:',
      key: 'manufactureYear',
      props: { direction: 'row' },
    },
    {
      label: 'Km de entrada na frota:',
      key: 'inclusionKm',
      props: {
        direction: 'row',
        parser: (value: string) => `${value} Km`,
      },
    },
    {
      label: 'Km atual:',
      key: 'currentKm',
      props: {
        direction: 'row',
        parser: (value: string) => `${value} Km`,
      },
    },
  ],
  [ContentRoutes.Checklists]: [
    {
      label: 'Regional:',
      key: 'regional.label',
      props: { direction: 'row' },
    },
    {
      label: 'Tipo:',
      key: 'type.label',
      props: { direction: 'row' },
    },
    {
      label: 'Frequência:',
      key: 'frequency',
      props: { direction: 'row' },
    },
  ],
  [ContentRoutes.QRCode]: [
    {
      label: 'Nome:',
      key: 'name',
      props: { direction: 'row' },
    },
    {
      label: 'Quantidade:',
      key: 'amount',
      props: { direction: 'row' },
    },
    {
      label: 'Link:',
      key: 'url',
      props: { direction: 'row' },
    },
  ],
  [`${ContentRoutes.Checklists}-execution`]: [
    {
      label: 'Tipo:',
      key: 'type.label',
      props: { direction: 'row' },
    },
    {
      label: 'Veículo:',
      key: 'vehicle.licensePlate',
      props: { direction: 'row' },
    },
    {
      label: 'Data do Checklist:',
      key: 'createdAt',
      props: {
        direction: 'row',
        parser: (value: string) => dayjs(value).format('DD/MM/YYYY'),
      },
    },
    {
      label: 'Frequência:',
      key: 'frequency',
      props: { direction: 'row' },
    },
    {
      label: 'Modelo:',
      key: 'vehicle.model',
      props: { direction: 'row' },
    },
    {
      label: 'Condutor:',
      key: 'driver.name',
      props: { direction: 'row' },
    },
  ],
  [ContentRoutes.VehicleAccessories]: [
    {
      label: 'ID do Acessório:',
      key: 'id',
      props: { direction: 'row' },
    },
    {
      label: 'Data de Calibração:',
      key: 'calibrationDate',
      props: {
        direction: 'row',
        parser: (value: Date) => dayjs(value).format('DD/MM/YYYY'),
      },
    },
    {
      label: 'Tipo:',
      key: 'accessoryType.name',
      props: {
        direction: 'row',
      },
    },
    {
      label: 'Validade da Calibração:',
      key: 'calibrationDueDate',
      props: {
        direction: 'row',
        parser: (value: Date) => dayjs(value).format('DD/MM/YYYY'),
      },
    },
    {
      label: 'Número de série:',
      key: 'serialNumber',
      props: {
        direction: 'row',
      },
    },
    {
      label: 'Veículo vinculado:',
      key: 'vehicle',
      props: {
        direction: 'row',
        parser: (value: any) => (typeof value === 'object' ? `${value.licensePlate} = ${value.model}` : value),
      },
    },
    {
      label: 'Número do Patrimônio:',
      key: 'assetNumber',
      props: {
        direction: 'row',
      },
    },
  ],
  [ContentRoutes.Trainings]: [
    {
      label: 'Data de Início:',
      key: 'startDate',
      props: {
        direction: 'row',
        parser: (value: Date) => dayjs(value).format('DD/MM/YYYY'),
      },
    },
    {
      label: 'Data de Concusão:',
      key: 'dueDate',
      props: {
        direction: 'row',
        parser: (value: Date) => dayjs(value).format('DD/MM/YYYY'),
      },
    },
    {
      label: 'Regional:',
      key: 'regional.name',
      props: {
        direction: 'row',
      },
    },
    {
      key: 'description',
      props: {
        direction: 'row',
      },
    },
  ],
};

export const relations = {
  [ContentRoutes.Project]: [{
    label: 'Rotas vinculadas',
    icon: 'map-marked-alt',
    key: [ContentRoutes.Routes],
  },
  {
    label: 'Condutores vinculados',
    icon: 'id-card',
    key: [ContentRoutes.Drivers],
  },
  {
    label: 'Parceiros vinculados',
    icon: 'handshake',
    key: [ContentRoutes.Partner],
  },
  {
    label: 'Veículos vinculados',
    icon: 'truck',
    key: [ContentRoutes.Vehicles],
  }],
  [ContentRoutes.Partner]: [
    {
      label: 'Rotas vinculadas',
      icon: 'map-marked-alt',
      key: [ContentRoutes.Routes],
    },
  ],
  [ContentRoutes.Vehicles]: [
    {
      label: 'Acessórios vinculados',
      icon: 'tachometer-alt',
      key: [ContentRoutes.AccessoryTypes],
    },
    {
      label: 'Rotas vinculadas',
      icon: 'map-marked-alt',
      key: [ContentRoutes.Routes],
    },
  ],
  [ContentRoutes.Companies]: [
    {
      label: 'Usuários vinculados',
      icon: 'users',
      key: [ContentRoutes.Drivers],
    },
    {
      label: 'Parceiros vinculados',
      icon: 'handshake',
      key: [ContentRoutes.Partner],
    },
    {
      label: 'Rotas vinculadas',
      icon: 'map-marked-alt',
      key: [ContentRoutes.Routes],
    },
    {
      label: 'Veículos vinculados',
      icon: 'truck',
      key: [ContentRoutes.Vehicles],
    },
    {
      label: 'Acessórios vinculados',
      icon: 'tachometer-alt',
      key: [ContentRoutes.AccessoryTypes],
    },
  ],
};

export const virtualizedListRelations = {
  [ContentRoutes.Vehicles]: [
    {
      cacheKey: `${ContentRoutes.Vehicles} - ${ContentRoutes.Checklists}`,
      Header: ChecklistExecutionHeader,
      getter: listChecklistExecutions,
      RenderItem: ChecklistExecutionItem,
      filterBy: 'vehicle.licensePlate',
      filterValue: 'licensePlate',
    },
  ],
  [ContentRoutes.Trainings]: [
    {
      cacheKey: `${ContentRoutes.Trainings} - ${ContentRoutes.Users}`,
      Header: UserAssignHeader,
      getter: listUsers,
      RenderItem: UserItem,
      filterBy: 'trainings.name',
      filterValue: 'name',
    },
    {
      cacheKey: `${ContentRoutes.Trainings} - ${ContentRoutes.Drivers}`,
      Header: DriverAssignHeader,
      getter: listDrivers,
      RenderItem: UserItem,
      filterBy: 'trainings.name',
      filterValue: 'name',
    },
  ],
};

export const columns = {
  [ContentRoutes.Partner]: 2,
  [ContentRoutes.Trainings]: 2,
  [ContentRoutes.VehicleAccessories]: 2,
  [ContentRoutes.Vehicles]: 3,
  [ContentRoutes.Checklists]: 3,
  [`${ContentRoutes.Checklists}-execution`]: 3,
};

export const filters = {
  [ContentRoutes.Project]: {
    filterBy: 'project.name',
    filterValue: 'name',
  },
  [ContentRoutes.Partner]: {
    filterBy: 'partner.name',
    filterValue: 'name',
  },
  [ContentRoutes.Vehicles]: {
    filterBy: 'vehicle.licensePlate',
    filterValue: 'licensePlate',
  },
};
